module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("itPOs"))).then(() => parcelRequire('d0iPb'));